import _ from 'lodash'
import { first } from 'rxjs/operators'

import { getTranslatedString, Location } from '@skinsoft/types'
import { SEARCH_TYPES } from '@skinsoft/const'
import { LocationOfflineDataFetcher } from '@skinsoft/offline'
import { EntityDataStore } from '@skinsoft/entity-data-store'

export class LocationDataStore extends EntityDataStore<Location> {
    public static getInstance() {
        if (!LocationDataStore.instance) {
            LocationDataStore.instance = new LocationDataStore();
        }

        return LocationDataStore.instance
    }

    public static install(Vue) {
        Vue.prototype.$locationDataStore = LocationDataStore.getInstance();
    }

    private static instance: LocationDataStore = null as any

    constructor() {
        super('locations', [SEARCH_TYPES.location])
    }

    /**
     * Replaces the ids in location pathId  with textual values
     * @param pathId 
     */
    public async resolvePath(pathId: string, locale: string, includeLastLevel: boolean = false): Promise<string> {
        let resolvedPath: string = ""
        if (pathId) {
            const ids = pathId.split("/")
            let index = 0;
            const lastlevelOffset = includeLastLevel ? 1 : 0;
            for (const id of ids) {
                if (id && index < ids.length - lastlevelOffset) {
                    const location = await this.fetchOne(id)
                        .pipe(first())
                        .toPromise()
                    const resolveName = getTranslatedString(location.translatedTitle, locale);
                    resolvedPath += `/${resolveName}`
                }
                index++;
            }
        }
        return resolvedPath
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new LocationOfflineDataFetcher(this.sanitizedIdentifer);
    }
}
